(function(){
  "use strict";

  var root;
  var drawer;
  var storageFailed = false;
  var lastTrigger;
  var customerId = "";

  function key(scope){
    return "bot:wishlist:" + scope;
  }

  function activeKey(){
    return key(customerId ? "customer:" + customerId : "guest");
  }

  function parse(value){
    try{
      var result = JSON.parse(value || "[]");
      return Array.isArray(result) ? result.filter(function(item){ return item && typeof item === "object" && item.id; }) : [];
    }catch(error){
      return [];
    }
  }

  function feedback(message){
    var target = root && root.classList.contains('is-open') ? root.querySelector('[data-bot-wishlist-status]') : document.querySelector('[data-bot-wishlist-page] [data-bot-wishlist-status]');
    if(!target) target = document.querySelector('[data-bot-wishlist-feedback]');
    document.querySelectorAll('[data-bot-wishlist-status], [data-bot-wishlist-feedback]').forEach(function(node){
      node.textContent = node === target ? message || '' : '';
      node.hidden = node !== target || !message;
    });
  }

  function read(storageKey){
    try { var items = parse(localStorage.getItem(storageKey)); storageFailed = false; return items; }
    catch(error){ storageFailed = true; feedback("Your saved products cannot be accessed in this browser right now."); return []; }
  }

  function write(items){
    if(storageFailed){ feedback("Your saved products cannot be accessed in this browser right now."); return false; }
    try { localStorage.setItem(activeKey(), JSON.stringify(items)); feedback(''); return true; }
    catch(error){ feedback("We couldn't save that change. Please try again."); return false; }
  }

  function mergeGuest(){
    if(!customerId) return;
    var guestKey = key("guest");
    var guest = read(guestKey);
    if(!guest.length) return;
    var account = read(activeKey());
    var seen = {};
    account.concat(guest).forEach(function(item){
      if(item && item.id) seen[String(item.id)] = item;
    });
    if(write(Object.keys(seen).map(function(id){ return seen[id]; }))) {
      try { localStorage.removeItem(guestKey); } catch(error) { /* Preserve the guest copy if removal is unavailable. */ }
    }
  }

  function safeURL(value, image){
    try {
      var url = new URL(value || '', location.origin);
      if(!/^https?:$/.test(url.protocol)) return '';
      if(image) return value ? url.href : '';
      var origins = [location.origin].concat((root.dataset.storeOrigins || '').split('|'));
      return origins.indexOf(url.origin) >= 0 ? url.pathname + url.search + url.hash : '';
    } catch(error) { return ''; }
  }

  function current(){
    return read(activeKey());
  }

  function updateControls(){
    var items = current();
    var saved = {};
    items.forEach(function(item){ saved[String(item.id)] = true; });

    document.querySelectorAll("[data-bot-wishlist-toggle]").forEach(function(button){
      var isSaved = !!saved[String(button.dataset.productId)];
      button.setAttribute("aria-pressed", isSaved ? "true" : "false");
      button.setAttribute("aria-label", (isSaved ? "Remove " : "Save ") + (button.dataset.productTitle || "product"));
      var label = button.querySelector("span");
      if(label) label.textContent = isSaved ? "Saved to Loves" : "Save to Loves";
    });

    document.querySelectorAll("[data-bot-wishlist-count]").forEach(function(badge){
      badge.textContent = String(items.length);
      badge.hidden = items.length === 0;
    });
  }

  function itemFromButton(button){
    return {
      id:String(button.dataset.productId || ""),
      handle:button.dataset.productHandle || "",
      title:button.dataset.productTitle || "",
      vendor:button.dataset.productVendor || "",
      url:button.dataset.productUrl || "",
      image:button.dataset.productImage || "",
      price:button.dataset.productPrice || ""
    };
  }

  function toggle(button){
    var item = itemFromButton(button);
    if(!item.id) return;
    var items = current();
    var found = items.findIndex(function(entry){ return String(entry.id) === item.id; });
    if(found >= 0) items.splice(found,1);
    else items.unshift(item);
    if(!write(items)) return;
    updateControls();
    render();
  }

  function render(){
    var items = current();
    document.querySelectorAll('[data-bot-wishlist-empty]').forEach(function(node){ node.hidden = items.length > 0; });
    document.querySelectorAll('[data-bot-wishlist-list]').forEach(function(list){
      list.hidden = items.length === 0;
      var fragment = document.createDocumentFragment();
      items.forEach(function(item){
        var row = document.createElement('article'); row.className = 'bot-wishlist-item';
        var url = safeURL(item.url, false);
        var picture = document.createElement(url ? 'a' : 'div'); picture.className = 'bot-wishlist-item__image';
        if(url) picture.setAttribute('href', url);
        var imageURL = safeURL(item.image, true);
        if(imageURL){ var image = document.createElement('img'); image.src = imageURL; image.alt = ''; image.width = 152; image.height = 152; image.loading = 'lazy'; picture.appendChild(image); }
        var details = document.createElement(url ? 'a' : 'div'); if(url) details.setAttribute('href',url);
        ['vendor','title','price'].forEach(function(field){ var text = document.createElement('div'); text.className = 'bot-wishlist-item__' + field; text.textContent = String(item[field] || ''); details.appendChild(text); });
        var remove = document.createElement('button'); remove.type = 'button'; remove.className = 'bot-wishlist-item__remove'; remove.dataset.botWishlistRemove = String(item.id); remove.setAttribute('aria-label','Remove ' + String(item.title || 'product'));
        var icon = document.createElementNS('http://www.w3.org/2000/svg','svg'); icon.setAttribute('viewBox','0 0 24 24'); icon.setAttribute('width','18'); icon.setAttribute('height','18'); icon.setAttribute('aria-hidden','true');
        var path = document.createElementNS('http://www.w3.org/2000/svg','path'); path.setAttribute('d','M3 6h18M8 6V4h8v2m-9 0 1 14h8l1-14M10 10v6m4-6v6'); icon.appendChild(path); remove.appendChild(icon);
        row.append(picture,details,remove); fragment.appendChild(row);
      });
      list.replaceChildren(fragment);
    });
  }

  function open(trigger){
    if(!root) return;
    lastTrigger = trigger || document.activeElement;
    root.inert = false;
    root.classList.add("is-open");
    root.setAttribute("aria-hidden","false");
    document.body.classList.add("bot-wishlist-opened");
    render();
    window.setTimeout(function(){
      var close = drawer.querySelector("[data-bot-wishlist-close]");
      if(close) close.focus();
    },0);
  }

  function close(){
    if(!root) return;
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden","true");
    root.inert = true;
    document.body.classList.remove("bot-wishlist-opened");
    if(lastTrigger && lastTrigger.isConnected && !lastTrigger.closest('[aria-hidden="true"], [inert]')) lastTrigger.focus();
    else { var fallback = document.getElementById("shopBtn3"); if(fallback) fallback.focus(); }
  }

  function init(){
    root = document.querySelector("[data-bot-wishlist-root]");
    if(!root) return;
    drawer = root.querySelector(".bot-wishlist-drawer");
    customerId = root.dataset.customerId || "";
    mergeGuest();
    updateControls();
    render();

    window.BotWishlist = { refresh: updateControls };
    new MutationObserver(function(records){
      if(records.some(function(record){ return Array.from(record.addedNodes).some(function(node){ return node.nodeType === 1 && (node.matches('[data-bot-wishlist-toggle],[data-bot-wishlist-count]') || node.querySelector('[data-bot-wishlist-toggle],[data-bot-wishlist-count]')); }); })) updateControls();
    }).observe(document.body,{childList:true,subtree:true});
    window.addEventListener('storage',function(event){ if(event.key === activeKey()){ storageFailed = false; updateControls(); render(); } });
    document.addEventListener("click",function(event){
      var toggleButton = event.target.closest("[data-bot-wishlist-toggle]");
      if(toggleButton){
        event.preventDefault();
        event.stopPropagation();
        toggle(toggleButton);
        return;
      }
      var openButton = event.target.closest(".bot-wishlist-open");
      if(openButton){
        event.preventDefault();
        var sheet = openButton.closest('.shop-modal.open');
        if(sheet){
          var closeSheet = sheet.querySelector('.close-btn');
          if(closeSheet){
            var afterClose = function(e){ if(e.detail && e.detail.id === sheet.id){ document.removeEventListener('beauty:sheet-closed',afterClose); open(document.getElementById('shopBtn3') || openButton); } };
            document.addEventListener('beauty:sheet-closed',afterClose);
            closeSheet.click();
          }
        } else open(openButton);
        return;
      }
      var closeButton = event.target.closest("[data-bot-wishlist-close]");
      if(closeButton){
        event.preventDefault();
        close();
        return;
      }
      var removeButton = event.target.closest("[data-bot-wishlist-remove]");
      if(removeButton){
        var id = String(removeButton.dataset.botWishlistRemove || "");
        if(!write(current().filter(function(item){ return String(item.id) !== id; }))) return;
        updateControls();
        render();
      }
    });

    document.addEventListener("keydown",function(event){
      if(!root.classList.contains('is-open')) return;
      if(event.key === 'Escape'){ event.preventDefault(); close(); return; }
      if(event.key === 'Tab'){
        var controls = Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),[tabindex]')).filter(function(node){ return node.tabIndex >= 0 && node.getClientRects().length && !node.closest('[hidden],[inert]'); });
        var first = controls[0], last = controls[controls.length-1];
        if(!first){ event.preventDefault(); return; }
        if(event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))){ event.preventDefault(); last.focus(); }
        else if(!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))){ event.preventDefault(); first.focus(); }
      }
    });
  }

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded",init);
  else init();
})();
